import React from 'react';

const Loader = () => (
    <div className="ui-loading" />
);

export default Loader;
